<template>
  <div>
    <v-snackbar :value="updateExists" left bottom :timeout="-1" color="primary">
      <h3>
        An update is available!
        <v-btn @click="refreshApp" class="ml-4">
          <v-icon>refresh</v-icon>
          Update
        </v-btn>
      </h3>
    </v-snackbar>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
// import SWMixin from "@/mixins/sw.mixin";


export default defineComponent({
  name: "SWUpdate",
  // mixins: [SWMixin],
});
</script>
